import { RequestPagination } from "src/utils/types"
import { EducationCategory } from "../../entities/educationCategory"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id?: string
	search?: string
	parentCategoryId?: string | null
	fetch?: {
		childCategories?: boolean
		parentCategory?: boolean
	}
	pagination?: RequestPagination
}

export async function educationCategoryListApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/educationCategory/list/v1"
	const requester = new ApiRequester<RequestDataShape, EducationCategory[]>(endpoint)
	return await requester.sendRequest(payload, token)
}
